import { locationTypes } from './constants'

export const getReturnMethodsSuggestionLocation = ({ locations, deliveryMethods, canEditLogistics }) => {
  if (!canEditLogistics) return null
  if (!locations || !deliveryMethods) return null
  if (locations.length !== 1 || deliveryMethods.length > 0) return null

  const [location] = locations

  if (location.type !== locationTypes.warehouse || !location.has_return_method_templates) return null

  return location
}
